export enum AccountType {
  Client = 'client',
  Vendor = 'vendor',
  None = 'none'
}
